import ConfigurablePane from './_configurable-pane.js'
import FlexItemBase from './_flex-item-base.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'

export default {
  name: 'TextInput',
  values: {
    class: 'text-input',
    type: 'text',
    inputMode: 'text',
    maxLength: undefined,
    style: {
      base: {
        outline: undefined,
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: FlexItemBase,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      hover: {
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      error: {
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      focus: {
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      disabled: {
        cursor: 'default',
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      placeholder: {
        color: undefined,
      },
    },
  },
  meta: {
    extendable: false,
  },
}
